import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

@Component({
    selector: 'app-registry-steps-grafic',
    templateUrl: './registry-steps-grafic.component.html',
    styleUrls: ['./registry-steps-grafic.component.scss'],
    standalone: false
})
export class RegistryStepsGraficComponent implements OnInit, OnDestroy {

  page: number = 1;
  private destroy$ = new Subject<void>();

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.setPageFromUrl(this.router.url);

    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.setPageFromUrl(event.urlAfterRedirects);
        }
      });
  }

  setPageFromUrl(url: string): void {
    if (url.includes('/aboPayment/confirmation')) {
      this.page = 4;
    } else if (url.includes('/aboPayment/settings')) {
      this.page = 3;
    } else if (url.includes('/firstProduct')) {
      this.page = 5;
    } else if (url.includes('/organisation')) { 
      this.page = 2;
    } else if (url.includes('/confirmation')) {
      this.page = 1;
    } else {
      this.page = 1;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
